import { takeLatest } from 'redux-saga/effects';

import {
  SET_SHOW_LOCALIZATION_SETTINGS,
  SET_LANGUAGE,
  GET_COUNTRIES,
  SET_SELECTED_REGION,
  SET_LOCALIZATION_SETTINGS,
} from './actions';
import {
  onSetShowLocalizationSettings,
  onSetLanguage,
  onGetCountries,
  onSetSelectedRegion,
  onSetLocalizationSettings,
} from './effects';

export function* setShowLocalizationSettingsSaga() {
  yield takeLatest(
    // @ts-expect-error ts-migrate(2769) FIXME: No overload matches this call.
    SET_SHOW_LOCALIZATION_SETTINGS,
    onSetShowLocalizationSettings,
  );
}

export function* setLanguageSaga() {
  // @ts-expect-error ts-migrate(2769) FIXME: No overload matches this call.
  yield takeLatest(SET_LANGUAGE, onSetLanguage);
}

export function* getLanguagesSaga() {
  yield takeLatest(GET_COUNTRIES, onGetCountries);
}

export function* setSelectedRegionSaga() {
  // @ts-expect-error ts-migrate(2769) FIXME: No overload matches this call.
  yield takeLatest(SET_SELECTED_REGION, onSetSelectedRegion);
}

export function* setLocalizationSettingsSaga() {
  // @ts-expect-error ts-migrate(2769) FIXME: No overload matches this call.
  yield takeLatest(SET_LOCALIZATION_SETTINGS, onSetLocalizationSettings);
}
